const ItemTypes = {
  CALENDAR_ITEM: 'CALENDAR_ITEM',
  CALENDAR_RECIPE: 'CALENDAR_RECIPE',
}

export default ItemTypes
